import { cn } from '@lib/util/cn';
import { getProductPrice } from '@lib/util/get-product-price';
import type {
  ProductActionsVariantVM,
  ProductActionsVM,
} from 'types/view-models';
import StockIndicator from '../stock-indicator';

export default function ProductPrice({
  product,
  variant,
  inStock = false,
}: {
  product: ProductActionsVM;
  variant?: ProductActionsVariantVM;
  inStock?: boolean;
}) {
  const { cheapestPrice, variantPrice } = getProductPrice({
    product,
    variantId: variant?.id,
  });

  const selectedPrice = variant ? variantPrice : cheapestPrice;

  if (!selectedPrice) {
    return <div className="block w-32 h-9 bg-gray-100 animate-pulse" />;
  }

  return (
    <div className="flex items-center justify-between" translate="no">
      <div className="flex flex-col text-ui-fg-base">
        <span
          className={cn(
            'text-lg font-bold leading-[150%] text-brand-primary-900',
            {
              'text-fg-interactive-strong': selectedPrice.price_type === 'sale',
            },
          )}
        >
          {!variant && 'From '}
          <span
            data-testid="product-price"
            data-value={selectedPrice.calculated_price_number}
          >
            {selectedPrice.calculated_price}
          </span>
        </span>
        {selectedPrice.price_type === 'sale' && (
          <div className="flex items-center gap-x-2 mt-1">
            <span
              className="line-through text-sm text-ui-fg-muted"
              data-testid="original-product-price"
              data-value={selectedPrice.original_price_number}
            >
              {selectedPrice.original_price}
            </span>
            <span className="text-sm font-semibold text-fg-interactive-strong">
              -{selectedPrice.percentage_diff}% off
            </span>
          </div>
        )}
      </div>
      {variant ? <StockIndicator inStock={inStock} /> : null}
    </div>
  );
}
